import { render, staticRenderFns } from "./Spei.vue?vue&type=template&id=bff8e510&scoped=true"
import script from "./Spei.vue?vue&type=script&lang=ts"
export * from "./Spei.vue?vue&type=script&lang=ts"
import style0 from "./Spei.vue?vue&type=style&index=0&id=bff8e510&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff8e510",
  null
  
)

export default component.exports